// extracted by mini-css-extract-plugin
module.exports = {"layer-group-header":"style_layer-group-header__2VGaN","layer-group-header-text":"style_layer-group-header-text__1YfM9"};